export const AppVersion = "v0.0.1";

// const HOST = "LOCAL";
const HOST = "DEVELOPMENT";
// const HOST = "TEST";
// const HOST = "PRODUCTION";

//main url
const URL =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://develop.am8.au"
    : HOST === "TEST"
    ? "https://Sandbox.am8.au"
    : HOST === "PRODUCTION"
    ? "https://Login.am8.com.au"
    : "";

//file url
const Fileurl =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dsetting.am8.au/public"
    : HOST === "TEST"
    ? "https://bsetting.am8.au/public"
    : HOST === "PRODUCTION"
    ? "https://setting.am8.com.au/public"
    : "";

//base url
let User =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://duser.am8.au"
    : HOST === "TEST"
    ? "https://buser.am8.au"
    : HOST === "PRODUCTION"
    ? "https://user.am8.com.au"
    : "";
const Setting =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dsetting.am8.au"
    : HOST === "TEST"
    ? "https://bsetting.am8.au"
    : HOST === "PRODUCTION"
    ? "https://setting.am8.com.au"
    : "";
const Work =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dwork.am8.au"
    : HOST === "TEST"
    ? "https://bwork.am8.au"
    : HOST === "PRODUCTION"
    ? "https://work.am8.com.au"
    : "";
const Report =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dreport.am8.au"
    : HOST === "TEST"
    ? "https://breport.am8.au"
    : HOST === "PRODUCTION"
    ? "https://report.am8.com.au"
    : "";
const PayRoll =
  HOST === "LOCAL"
    ? ""
    : HOST === "DEVELOPMENT"
    ? "https://dpayroll.am8.au"
    : HOST === "TEST"
    ? "https://bpayroll.am8.au"
    : HOST === "PRODUCTION"
    ? "https://payroll.am8.com.au"
    : "";

const APP_URL = {
  User: User,
  Setting: Setting,
  Work: Work,
  Report: Report,
  PayRoll: PayRoll,
};

export { HOST, URL, APP_URL, Fileurl };
